import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _AbHealthComponentInfoFactory;
/* eslint-disable */
/**
 * Health
 * Ab Initio Health Services
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/health.yaml
// Template file: models.mustache (typescript-fetch)

// @ts-ignore noUnusedLocals
import { AbHealthBaseObjFactory } from "./AbHealthBaseObj";

/**
 * Defines the health of a system or subsystem (database, daemon, server, or service) that the application depends on, such as the bridge.
 * @export
 * @interface AbHealthComponentInfo
 */

export class AbHealthComponentInfoFactory {}
_AbHealthComponentInfoFactory = AbHealthComponentInfoFactory;
_defineProperty(AbHealthComponentInfoFactory, "FromJSON", function (json) {
  return _AbHealthComponentInfoFactory.FromJSONTyped(json, false);
});
_defineProperty(AbHealthComponentInfoFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'name': json['name'],
    'connected': json['connected'],
    'health': AbHealthBaseObjFactory.FromJSON(json['health']),
    'buildId': json['buildId'],
    'version': json['version'],
    'type': json['type']
  };
});
_defineProperty(AbHealthComponentInfoFactory, "ToJSON", function (value) {
  return _AbHealthComponentInfoFactory.ToJSONTyped(false, value);
});
_defineProperty(AbHealthComponentInfoFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'name': value.name,
    'connected': value.connected,
    'health': AbHealthBaseObjFactory.ToJSON(value.health),
    'buildId': value.buildId,
    'version': value.version,
    'type': value.type
  };
});
//# sourceMappingURL=AbHealthComponentInfo.js.map
